export enum TipoAcaoEnum {
	Insercao = 1,
	Alteracao = 2,
	Exclusao = 3,
	LogIn = 4,
	Acesso = 5,
	Avaliacao = 6,
	Auditoria = 7,
}
